import { useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { useSearchParams } from 'react-router-dom'

export default function useChangeLanguage() {
  const [searchParams] = useSearchParams()
  const language = searchParams.get('lang')
  const { i18n } = useTranslation()

  useEffect(() => {
    if (language) {
      localStorage.setItem('language', language)
      document.documentElement.setAttribute('lang', language)
      i18n.changeLanguage(language)
    }
  }, [i18n, language])
}
